import { apiMiddleware } from 'redux-api-middleware';
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import metricsMiddleware from './metricsMiddleware';
import postmongerMiddleware from './postmongerMiddleware';
import rootReducer from '../reducers';

//const devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

// attempting to see stack in redux dev tools
// TODO: Remove this before MR'ing to master
const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })) ||
  compose;

const logger = createLogger({
  collapsed: true,
});

const RootStore =
  process.env.NODE_ENV === 'production'
    ? createStore(
        rootReducer,
        compose(applyMiddleware(apiMiddleware, metricsMiddleware, postmongerMiddleware, thunk))
      )
    : createStore(
        rootReducer,
        composeEnhancers(
          applyMiddleware(apiMiddleware, metricsMiddleware, postmongerMiddleware, thunk, logger)
        )
      );

export default RootStore;



// WEBPACK FOOTER //
// ./src/Root/RootStore/configureStore.js